import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import Pagination from 'react-bootstrap/Pagination';
import "./HlzWorks.css";
import { hlzWorksTxt } from "../assets/HlzWorksData";

let active = 3;
let items = [];
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>,
  );
}

export function HlzWorks() {
  return (
    <section id='works' className='block hlzworks-block'>
      <Container fluid>
        <Row className='title-holder text-lg-center'>
          <h1>---HLZ Works---</h1>
          <div className='subtitle fs-3'>Our Aesome Works</div>
        </Row>
        <Row className='portfolio'> {
          hlzWorksTxt.map(works => {
            return (
              <Col sm={3} key={works.id}>
                <div className='works-table'>
                  <a href={works.link}>
                    <Image src={works.image} />
                    <div className='label text-center'>
                      <h3>{works.title}</h3>
                    </div>
                    {/* <div className='label text-center fs-6' style={{ whiteSpace: "pre-wrap" }}> ? */}
                    {/* <h4>{works.subtitle}</h4> */}
                  </a>
                </div>
              </Col>
            );
          })
        } </Row>
        {/* <Pagination>{items}</Pagination> */}
      </Container>
    </section>
  );
}

export default HlzWorks;